import { sitesConstants } from '../constants/sites';
import { sites } from '../services/ApiService';

export const setSites = (sites = []) => ({
  type: sitesConstants.SET_SITES_SUCCESS,
  sites,
});

export const startSetSites = params => dispatch => {
  return sites
    .getList(params)
    .then((data = {}) => dispatch(setSites(data.items)))
    .catch(err => dispatch({ type: sitesConstants.SET_SITES_FAILURE }));
};

export const removeSite = id => ({
  type: sitesConstants.REMOVE_SITE_SUCCESS,
  id,
});

// REMOVE SITE
export const startRemoveSite = id => dispatch =>
  sites
    .delete(id)
    .then(() => dispatch(removeSite(id)))
    .catch(err =>
      dispatch({
        type: sitesConstants.REMOVE_SITE_FAILURE,
        payload: err.response.data.error.message.message,
      }),
    );

export const editSite = (id, updates) => ({
  type: sitesConstants.EDIT_SITE_SUCCESS,
  id,
  updates,
});

// EDIT SITE
export const startEditSite = (id, updates) => dispatch => {
  return sites
    .update(id, updates)
    .then(() => dispatch(editSite(id, updates)))
    .catch(err => dispatch({ type: sitesConstants.EDIT_SITE_FAILURE }));
};

// ADD SITE
export const startAddSite = (siteData = {}) => dispatch => {
  return sites
    .create(siteData)
    .then((data = {}) => {
      dispatch({ type: sitesConstants.ADD_SITE_SUCCESS });
      return data.items;
    })
    .catch(err => dispatch({ type: sitesConstants.ADD_SITE_FAILURE }));
};
